import { url } from '@/helpers/UrlHelpers';
import ApiService from '@/services/ApiService';
import ApiEndpoints from '@/config/ApiEndpoints';

export default class GetAllProducts {
    apiService;

    constructor(apiService = null) {
        this.apiService = apiService || new ApiService(process.env.VUE_APP_API_URL);
    }

    handle() {
        let apiUrl = ApiEndpoints['products.families'];

        return this.apiService
            .get(apiUrl);
    }
}
